import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { currentUser, User } from '../../../../../core/auth';
import { CompanyService } from '../../../../../core/auth/_services/company.service';
import { AppState } from '../../../../../core/reducers';
import { LayoutUtilsService, QueryParamsModel, QueryResultsModel } from '../../../../../core/_base/crud';
import { SubheaderService } from '../../../../../core/_base/layout';

@Component({
	selector: 'kt-company-list',
	templateUrl: './company-list.component.html',
	styleUrls: []
})
export class CompanyListComponent implements OnInit, OnDestroy, AfterViewInit {


	// displayedColumns = ['select', 'active', 'login', 'group_name','login_date', 'actions'];
	filterList = [
	];
	columnList = [
		// {name: 'id', displayName: 'ID', def: 'id' },
		{ name: 'name', displayName: 'Nombre', def: 'name' },
		{ name: 'theme_name', displayName: 'Tema', def: 'theme_name' },
		{ name: 'icon_file', displayName: 'Icono', def: 'icon_file', isImg: true, imageType: (row)=>{
			if(row.icon_filename){
				const splited = row.icon_filename.split('.');
				return splited[splited.length-1];
			}
				
			return 'png';
		}},
		{ name: 'icon_filename', displayName: 'Nombre Icono', def: 'icon_filename'},
		{ name: 'comments', displayName: 'Comentarios', def: 'comments'},
		{ name: 'partner_email', displayName: 'Email', def: 'partner_email'},
		{ name: 'partner_mobile', displayName: 'Contacto', def: 'partner_mobile'},
		{ name: 'partner_street', displayName: 'Dirección', def: 'partner_street'},
		{ name: 'partner_rut', displayName: 'Rut', def: 'partner_rut'},
		{ name: 'partner_website', displayName: 'Web', def: 'partner_website'},
		{ name: 'write_date', displayName: 'Última modificación', def: 'write_date', isDate: true},
	];
	actionBtns = [];
	inited = false;
	dataObs: Subject<QueryResultsModel> = new Subject<QueryResultsModel>();
	deleteObs: Subject<string> = new Subject<string>();
	subscriptions: Subscription[] = [];
	lastQuery: QueryParamsModel;
	user$: Observable<User>;
	
	constructor(
		private companyService: CompanyService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private layoutUtilsService: LayoutUtilsService,
		private subheaderService: SubheaderService,
		private cdr: ChangeDetectorRef,
		private store: Store<AppState>,
	) { }

	ngOnInit() {
		this.inited = true;
		this.user$ = this.store.pipe(select(currentUser));
		this.subscriptions.push(this.user$.subscribe((user)=>{
			console.log("usuario: ");console.dir(user);
		}));
	}

	deleteOne(userId: number) {
		this.subscriptions.push(
			of(null).pipe(
				switchMap(() => this.companyService.delete({ id: userId }))
			).subscribe(status => {
				this.deleteObs.next(status);
			})
		);
	}

	getPage(query: QueryParamsModel) {
		// this.lastQuery = Object.assign(query, {filter: Object.assign(query.filter, {is_installation_contact: 'true'})});
		console.log(`query get page: ${JSON.stringify(query)}`);
		this.subscriptions.push(
			of(null).pipe(
				switchMap(() => this.companyService.getPage(query))
			).subscribe(res => {
				// console.log(`query result: ${JSON.stringify(res)}`);
				this.dataObs.next(res);
			})
		);
	}

	refresh() {
		this.getPage(this.lastQuery);
	}

	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}

	ngAfterViewInit() {
	}
}